import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-585dfca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "old-report-page" }
const _hoisted_2 = { class: "old-report-page__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_w_report_header = _resolveComponent("w-report-header")!
  const _component_w_report_images = _resolveComponent("w-report-images")!
  const _component_e_old_result_analyzes = _resolveComponent("e-old-result-analyzes")!
  const _component_e_old_observation_history = _resolveComponent("e-old-observation-history")!
  const _component_w_report_comments = _resolveComponent("w-report-comments")!
  const _component_e_old_recommendations = _resolveComponent("e-old-recommendations")!
  const _component_w_report_submit = _resolveComponent("w-report-submit")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_w_report_header, {
        "report-info": _ctx.reportInfo,
        "report-type": _ctx.REPORT_VIEW.plaqueIndex,
        "is-old": ""
      }, null, 8, ["report-info", "report-type"]),
      _createVNode(_component_w_report_images, {
        images: _ctx.reportInfo.images
      }, null, 8, ["images"]),
      _withDirectives(_createVNode(_component_e_old_result_analyzes, {
        "result-analyzes": _ctx.resultAnalyzes,
        class: "old-report-page__card"
      }, null, 8, ["result-analyzes"]), [
        [_directive_loading, _ctx.analyzesLoading]
      ]),
      (_ctx.patientId !== 'null-patient')
        ? (_openBlock(), _createBlock(_component_e_old_observation_history, {
            key: 0,
            "observation-history": _ctx.observationHistory,
            class: "old-report-page__card"
          }, null, 8, ["observation-history"]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_w_report_comments, {
        key: _ctx.comments,
        comments: _ctx.comments,
        "report-type": _ctx.REPORT_VIEW.plaqueIndex,
        class: "old-report-page__card",
        "is-old": ""
      }, null, 8, ["comments", "report-type"])),
      _createVNode(_component_e_old_recommendations, {
        consultation: _ctx.consultation,
        class: "old-report-page__card"
      }, null, 8, ["consultation"]),
      (_ctx.patientId !== 'null-patient')
        ? (_openBlock(), _createBlock(_component_w_report_submit, {
            key: 1,
            email: _ctx.email,
            "report-type": _ctx.REPORT_VIEW.plaqueIndex
          }, null, 8, ["email", "report-type"]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [
      _directive_loading,
      _ctx.loading,
      void 0,
      { body: true }
    ]
  ])
}